<template>
  <div>
    <el-dialog
      :title="form.id ? '编辑' : '新建'"
      :visible.sync="formVisible"
      top="3vh"
      width="1100px"
      :close-on-click-modal="false"
      append-to-body
      :before-close="handleDialogClose"
    >
      <div
        class="content"
        :style="'height: ' + windowHeight + 'px; overflow-y: auto;'"
      >
        <div class="reimbursement">
          <el-form
            ref="dataForm"
            :rules="formRules"
            :model="form"
            label-position="right"
            size="small"
            label-width="110px"
          >
            <el-card class="box-card treeselect-wrapper">
              <el-descriptions title="物料分类"></el-descriptions>
              <el-form-item
                label="物料分类:"
                prop="classificationId"
                class="width100"
              >
                <treeselect
                  v-model="form.classificationId"
                  :options="categorizeOptions"
                  :normalizer="normalizer"
                  :show-count="true"
                  no-options-text="暂无数据"
                  placeholder="请选择"
                  :disable-branch-nodes="true"
                  :flat="false"
                  @select="handleSelect"
                />
              </el-form-item>
            </el-card>
            <el-card class="box-card mt10">
              <el-descriptions title="文章基础消息"></el-descriptions>
              <el-row>
                <el-col :span="6">
                  <el-form-item
                    label="物料信息:"
                    prop="coverImage"
                    class="width100"
                  >
                    <imageUpload
                      v-model="form.coverImage"
                      width="120"
                      height="80"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item
                    label="标题:"
                    prop="titleJson"
                    label-width="70px"
                    class="width100 title-form-item"
                    required
                  >
                    <div class="title-tips">
                      勾选中的内容，支持在app分享的时候编辑该内容
                    </div>
                  </el-form-item>
                  <div class="material-info-wrapper">
                    <div class="material-info-container">
                      <div
                        v-for="(item, index) in form.titleJson"
                        :key="index"
                        class="material-info-item"
                      >
                        <el-checkbox
                          v-model="item.isEdit"
                          :true-label="1"
                          :false-label="0"
                          class="material-checkbox"
                        ></el-checkbox>
                        <el-input
                          v-model="item.titleName"
                          placeholder="请输入标题"
                          class="material-input"
                          :id="`titleJson_${index}`"
                          @input="handleTitleInput"
                        />
                        <div class="material-actions">
                          <el-button
                            type="success"
                            icon="el-icon-plus"
                            size="mini"
                            @click="addMaterialInfo"
                            class="action-btn add-btn"
                          ></el-button>
                          <el-button
                            type="danger"
                            icon="el-icon-minus"
                            size="mini"
                            @click="removeMaterialInfo(index)"
                            :disabled="form.titleJson.length <= 1"
                            class="action-btn remove-btn"
                          ></el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-form-item
                label="会议:"
                prop="meetingId"
                label-for="meetingId"
              >
                <el-select
                  v-model="form.meetingId"
                  placeholder="请选择"
                  clearable
                  size="small"
                  @change="changeMeeting"
                  id="meetingId"
                >
                  <el-option
                    v-for="(item, index) in meetingOptions"
                    :key="index"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序:" prop="orderNo" label-for="orderNo">
                <el-input
                  v-model="form.orderNo"
                  placeholder="请输入排序值"
                  id="orderNo"
                />
              </el-form-item>
              <el-form-item
                label="虚拟数据配置"
                class="width100"
                prop="virtualData"
              >
                <div style="display: flex;justify-content: space-between;">
                  <div style="display: flex;align-items: center;">
                    <label
                      for="browseNum"
                      style="width: 60px;text-align: right;margin-right: 10px;cursor: pointer;" prop="browseNum"
                      >浏览量:
                    </label>
                    <el-input
                      v-model="form.browseNum"
                      placeholder="请输入虚拟浏览量"
                      id="browseNum"
                      @blur="validateVirtualData"
                    />
                  </div>
                  <div style="display: flex;align-items: center;">
                    <label
                      for="likeNum"
                      style="width: 60px;text-align: right;margin-right: 10px;cursor: pointer;" prop="likeNum"
                      >点赞量:
                    </label>
                    <el-input
                      v-model="form.likeNum"
                      placeholder="请输入虚拟点赞量"
                      id="likeNum"
                      @blur="validateVirtualData"
                    />
                  </div>
                  <div style="display: flex;align-items: center;">
                    <label
                      for="forwardNum"
                      style="width: 60px;text-align: right;margin-right: 10px;cursor: pointer;" prop="forwardNum"
                      >转发量:
                    </label>
                    <el-input
                      v-model="form.forwardNum"
                      placeholder="请输入虚拟转发量"
                      id="forwardNum"
                      @blur="validateVirtualData"
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="状态:" prop="state" class="width100">
                <el-switch
                  v-model="form.state"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </el-form-item>
            </el-card>
            <el-card class="box-card mt10">
              <el-descriptions title="文章详情"></el-descriptions>
              <el-form-item
                label="文章logo图："
                prop="logoImg"
                class=""
                label-for="logoImg"
              >
                <imageUpload v-model="form.logoImg" width="120" height="80" />
              </el-form-item>
              <el-form-item
                label="技术老师描述："
                class="width100"
                prop="teacherIsEdit"
                label-for="teacherIsEdit"
              >
                <el-checkbox
                  v-model="form.teacherIsEdit"
                  :true-label="1"
                  :false-label="0"
                  id="teacherIsEdit"
                  >允许分享时更换技术老师</el-checkbox
                >
                <div
                  style="display: flex; align-items: center; gap: 12px; margin-top: 10px;"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    plain
                    @click="selectImage"
                    >选择默认技术老师</el-button
                  >
                  <div
                    v-if="teacherInfo"
                    style="display: flex; align-items: center; gap: 12px; padding: 8px 12px; background: #f5f7fa; border-radius: 4px;"
                  >
                    <el-image
                      style="width: 40px; height: 40px; border-radius: 50%;"
                      :src="teacherInfo.promotionImg"
                      :preview-src-list="[teacherInfo.promotionImg]"
                    ></el-image>
                    <div
                      style="display: flex; flex-direction: column; gap: 4px;"
                    >
                      <span
                        style="font-size: 14px; font-weight: 500; color: #303133;"
                        >{{ teacherInfo.name }}</span
                      >
                      <span style="font-size: 12px; color: #909399;">{{
                        teacherInfo.phone
                      }}</span>
                      <span style="font-size: 12px; color: #606266;">{{
                        teacherInfo.identity
                      }}</span>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                label="时间："
                prop="contactTime"
                label-for="contactTime"
              >
                <el-date-picker
                  v-model="form.contactTime"
                  size="small"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择时间"
                  id="contactTime"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="地址："
                prop="contactAddress"
                label-for="contactAddress"
              >
                <el-input
                  v-model="form.contactAddress"
                  placeholder="请选择地址"
                  readonly
                  id="contactAddress"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-location-outline"
                    style="color: #1296DB"
                  ></i>
                </el-input>
                <span class="address" @click="addAddressShow = true"></span>
              </el-form-item>
              <el-form-item label="联系人：" label-for="contactName">
                <el-input
                  v-model="form.contactName"
                  placeholder="请输入联系人姓名"
                  id="contactName"
                />
              </el-form-item>
              <el-form-item label="联系号码：" label-for="contactPho">
                <el-input
                  v-model="form.contactPho"
                  placeholder="请输入联系人手机号码"
                  id="contactPho"
                />
              </el-form-item>
              <el-form-item label="内容" prop="contentList" class="width100">
                <div class="content-container">
                  <div class="content-list">
                    <div
                      v-for="(item, index) in form.contentList"
                      :key="index"
                      class="content-item-wrapper"
                    >
                      <div class="content-item-header">
                        <div class="content-footer">
                          <el-checkbox
                            v-model="item.isEdit"
                            :true-label="1"
                            :false-label="0"
                            class="content-checkbox"
                          >
                            支持分享编辑内容
                          </el-checkbox>
                          <div class="content-actions">
                            <span
                              class="action-link add-link"
                              @click="addContent"
                              >新增</span
                            >
                            <span
                              class="action-link delete-link"
                              @click="removeContent(index)"
                              :class="{
                                disabled: form.contentList.length <= 1
                              }"
                              >删除</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="content-item-body">
                        <div class="content-editor">
                          <editor
                            :key="`content-editor-${index}-${formVisible}`"
                            v-model="item.content"
                            :min-height="200"
                            :height="200"
                            :upload-url="uploadUrl"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-card>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">取消</el-button>
            <el-button type="primary" @click="doCreate()">确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <select-img-vue ref="selectImgVue" @created="handleSelectImg" />
    <addAddress
      :positionDialog="addAddressShow"
      @handlePositionDialog="handlePositionDialog"
      @updatePositionDialog="updatePositionDialog"
      @handleCloes="handleCloes"
    />
  </div>
</template>

<script>
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";
import templateTeacherApi from "@/api/marketing/templateTeacher";
import templateClassificationApi from "@/api/marketing/templateClassification";
import ImageUpload from "@/components/ImageUpload";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Editor from "@/components/Editor";
import MoreImageUpload from "@/components/MoreImageUpload";
import addAddress from "@/components/map/index";
import selectImgVue from "./selectImg.vue";
import meetingApi from "@/api/meeting/meeting";
function initFormBean() {
  const formBean = {
    id: undefined,
    classificationId: undefined,
    classificationCode: "",
    coverImage: undefined,
    titleJson: [{ isEdit: 0, titleName: "" }],
    contentList: [
      {
        content: "",
        isEdit: 0
      }
    ],
    orderNo: 0,
    state: 1,
    browseNum: undefined,
    likeNum: undefined,
    forwardNum: undefined,
    logoImg: undefined,
    meetingId: undefined,
    contactTime: undefined,
    contactAddress: "",
    contactName: "",
    contactPho: "",
    teacherId: undefined,
    teacherIsEdit: 0,
    type: 1,
    collectNum: 0
  };
  return formBean;
}

export default {
  props: ["categorizeOptions"],
  components: {
    ImageUpload,
    Treeselect,
    Editor,
    MoreImageUpload,
    addAddress,
    selectImgVue
  },
  data() {
    return {
      addAddressShow: false,
      uploadUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload",
      form: initFormBean(),
      formVisible: false,
      formRules: {
        titleJson: [
          {
            validator: (rule, value, callback) => {
              if (!value || !Array.isArray(value) || value.length === 0) {
                callback(new Error("至少需要添加一个标题"));
                return;
              }
              // 检查是否至少有一个 titleName 有值
              const hasValidTitle = value.some(
                item => item && item.titleName && item.titleName.trim() !== ""
              );
              if (!hasValidTitle) {
                callback(new Error("至少需要填写一个标题"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        classificationId: [
          { required: true, message: "请选择分类", trigger: "change" }
        ],
        coverImage: [
          { required: true, message: "请上传封面图", trigger: "change" }
        ],
        orderNo: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { pattern: /^[0-9]*$/, message: "排序必须为数字值", trigger: "blur" }
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
        virtualData: [
          {
            validator: (rule, value, callback) => {
              const browseNum = this.form.browseNum;
              const likeNum = this.form.likeNum;
              const forwardNum = this.form.forwardNum;
              
              if (browseNum === undefined || browseNum === null || browseNum === "") {
                callback(new Error("请输入虚拟浏览量"));
                return;
              }
              if (likeNum === undefined || likeNum === null || likeNum === "") {
                callback(new Error("请输入虚拟点赞量"));
                return;
              }
              if (forwardNum === undefined || forwardNum === null || forwardNum === "") {
                callback(new Error("请输入虚拟转发量"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        browseNum: [{ required: true, message: "请输入虚拟浏览量", trigger: "blur" }],
        likeNum: [{ required: true, message: "请输入虚拟点赞量", trigger: "blur" }],
        forwardNum: [{ required: true, message: "请输入虚拟转发量", trigger: "blur" }]
      },
      isRepSub: false,
      activeType: 1,
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      imgUrl: "",
      teacherInfo: null, // 保存技术老师的完整信息
      meetingOptions: [],
      internalCategorizeOptions: [] // 内部维护的分类选项
    };
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getMeeting();
    // 移除这里的 getCategorizeOptions() 调用，避免重复请求
    // 分类数据由父组件 list.vue 通过 props 传入，如果没有再按需加载
  },
  methods: {
    handleSelect(node) {},
    // 处理标题输入，清除验证
    handleTitleInput() {
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate("titleJson");
        }
      });
    },
    // 验证虚拟数据配置
    validateVirtualData() {
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].validateField("virtualData");
        }
      });
    },
    // 解析标题列表，兼容字符串与数组
    parseTitleList(input) {
      try {
        const arr = typeof input === "string" ? JSON.parse(input) : input;
        if (Array.isArray(arr) && arr.length > 0) {
          return arr.map(it => ({
            titleName: (it && (it.titleName || it.name || "")) || "",
            isEdit: it && typeof it.isEdit !== "undefined" ? it.isEdit : 0
          }));
        }
      } catch (e) {}
      return [{ isEdit: 0, titleName: "" }];
    },
    // 解析内容列表，兼容字符串与数组
    parseContentList(input) {
      // 处理 null/undefined
      if (!input) {
        return [{ content: "", isEdit: 0 }];
      }
      try {
        let arr = input;
        // 如果是字符串，尝试解析
        if (typeof input === "string" && input.trim()) {
          arr = JSON.parse(input);
        }
        // 确保是数组
        if (Array.isArray(arr) && arr.length > 0) {
          return arr.map(it => {
            let content = String((it && it.content) || "");
            // 确保content是纯HTML字符串，清理所有转义字符
            // JSON.parse已经处理了JSON转义，content应该是纯HTML
            // 但如果还有转义字符，需要清理
            if (content.includes('\\"') || content.includes("\\'")) {
              content = content.replace(/\\"/g, '"').replace(/\\'/g, "'");
            }
            return {
              content: content,
              isEdit: it && typeof it.isEdit !== "undefined" ? it.isEdit : 0
            };
          });
        }
      } catch (e) {
        console.warn("解析contentList失败:", e, input);
      }
      return [{ content: "", isEdit: 0 }];
    },
    getMeeting() {
      meetingApi.fetchListForMini({ status: 10, statusSub: 11 }).then(data => {
        this.meetingOptions = data.data;
      });
    },
    // 处理会议选择变化
    changeMeeting(value) {
      // 会议选择变化时的处理逻辑
      // 如果需要，可以在这里添加额外的处理
    },
    // 获取物料分类选项
    getCategorizeOptions() {
      return templateClassificationApi
        .fetchTreeList({ pageNo: 1, pageSize: 1000, state: 1, sourceType: 1 })
        .then(({ data }) => {
          if (data && data.list) {
            // 深拷贝数据并格式化，避免修改原始数据
            const formattedData = JSON.parse(JSON.stringify(data.list));
            this.internalCategorizeOptions = this.formatCascaderData(
              formattedData
            );
          }
          return this.internalCategorizeOptions;
        })
        .catch(err => {
          console.error("获取物料分类失败:", err);
          return [];
        });
    },
    // 格式化级联数据
    formatCascaderData(data) {
      if (!Array.isArray(data)) return [];
      // 深拷贝处理，避免修改原始数据
      return data.map(item => {
        const formattedItem = { ...item };
        if (formattedItem.childList && formattedItem.childList.length > 0) {
          // 递归处理子节点
          formattedItem.childList = this.formatCascaderData(
            formattedItem.childList
          );
        } else {
          // 如果没有子节点或子节点为空，设为undefined（treeselect需要）
          formattedItem.childList = undefined;
        }
        return formattedItem;
      });
    },
    normalizer(node) {
      if (node.childList && !node.childList.length) {
        delete node.childList;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.childList
      };
    },
    /**
     * 在树结构中根据id查找节点并返回code
     * @param {Array} tree 树结构数组
     * @param {Number|String} id 要查找的id
     * @returns {String|null} 找到的code值，未找到返回null
     */
    findCodeById(tree, id) {
      if (!tree || !Array.isArray(tree) || id === null || id === undefined) {
        return null;
      }
      for (const node of tree) {
        // 比较id，支持数字和字符串类型
        if (node.id === id || node.id === Number(id) || String(node.id) === String(id)) {
          return node.code || null;
        }
        // 递归查找子节点，兼容childList和children两种字段名
        const children = node.childList || node.children;
        if (children && Array.isArray(children) && children.length > 0) {
          const code = this.findCodeById(children, id);
          if (code !== null) {
            return code;
          }
        }
      }
      return null;
    },
    // 添加物料信息项
    addMaterialInfo() {
      this.form.titleJson.push({
        titleName: "",
        isEdit: 0
      });
    },
    // 删除物料信息项
    removeMaterialInfo(index) {
      if (this.form.titleJson.length > 1) {
        this.form.titleJson.splice(index, 1);
      }
    },
    // 添加内容项
    addContent() {
      this.form.contentList.push({
        content: "",
        isEdit: 0
      });
    },
    // 删除内容项
    removeContent(index) {
      if (this.form.contentList.length > 1) {
        this.form.contentList.splice(index, 1);
      }
    },
    selectImage() {
      this.$refs.selectImgVue.handleCreate();
    },
    handleSelectImg(find) {
      this.imgUrl = find.promotionImg;
      this.form.teacherId = find.id;
      // 保存技术老师的完整信息
      this.teacherInfo = {
        id: find.id,
        promotionImg: find.promotionImg,
        name: find.name || "",
        phone: find.phone || "",
        identity: find.identity || ""
      };
    },
    //选择地址
    handlePositionDialog(val) {
      this.addAddressShow = false;
      this.form.contactAddress = val.mapText;
      // this.form.latitude = val.latitude;
      // this.form.longitude = val.longitude;
    },
    updatePositionDialog(val) {
      this.addAddressShow = val;
    },
    handleCloes(val) {
      this.addAddressShow = val;
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean();
      this.teacherInfo = null;
      this.imgUrl = "";
    },
    /**
     * 处理对话框关闭
     */
    handleDialogClose(done) {
      // 重置表单
      this.resetForm();
      // 关闭对话框
      done();
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm();
      this.formVisible = true;
    },
    handleUpdate(row) {
      this.resetForm();
      // 获取 id，优先从 templateMaterialsSharePO 中获取
      const id =
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id) ||
        row.id;

      if (!id) {
        this.$common.showMsg("error", "缺少分享物料ID");
        return;
      }

      // 加载数据
      templateMaterialsShareApi
        .fetchById(id)
        .then(res => {
          const responseData = res.data || {};
          const sharePO =
            responseData.templateMaterialsSharePO || responseData || {};

          // 处理 classificationId
          let classificationId = sharePO.classificationId;
          if (
            classificationId !== null &&
            classificationId !== undefined &&
            classificationId !== ""
          ) {
            classificationId = Number(classificationId);
            if (isNaN(classificationId)) {
              classificationId = undefined;
            }
          } else {
            classificationId = undefined;
          }

          // 回填表单数据
          this.form = {
            id: sharePO.id || id,
            classificationId: classificationId,
            coverImage: sharePO.coverImage,
            orderNo: sharePO.orderNo || 0,
            state: sharePO.state !== undefined ? sharePO.state : 1,
            browseNum: sharePO.browseNum,
            likeNum: sharePO.likeNum,
            forwardNum: sharePO.forwardNum,
            logoImg: sharePO.logoImg,
            meetingId: sharePO.meetingId,
            contactTime: sharePO.contactTime,
            contactAddress: sharePO.contactAddress || "",
            contactName: sharePO.contactName || "",
            contactPho: sharePO.contactPho || "",
            teacherId: sharePO.teacherId,
            teacherIsEdit:
              sharePO.teacherIsEdit !== undefined ? sharePO.teacherIsEdit : 0,
            titleJson: this.parseTitleList(sharePO.titleJson),
            contentList: this.parseContentList(sharePO.content),
            type: 1,
            collectNum: 0
          };
          // 如果有技术老师ID，加载技术老师信息
          if (sharePO.teacherId) {
            templateTeacherApi
              .fetchById(sharePO.teacherId)
              .then(teacherRes => {
                const teacherData = teacherRes.data || {};
                this.imgUrl = teacherData.promotionImg || "";
                this.teacherInfo = {
                  id: teacherData.id || sharePO.teacherId,
                  promotionImg: teacherData.promotionImg || "",
                  name: teacherData.name || "",
                  phone: teacherData.phone || "",
                  identity: teacherData.identity || ""
                };
              })
              .catch(err => {
                console.error("获取技术老师信息失败:", err);
                this.imgUrl = "";
                this.teacherInfo = null;
              });
          } else {
            this.imgUrl = "";
            this.teacherInfo = null;
          }

          // 打开对话框
          this.formVisible = true;
          // 清除验证
          this.$nextTick(() => {
            if (this.$refs["dataForm"]) {
              this.$refs["dataForm"].clearValidate();
            }
          });
        })
        .catch(err => {
          console.error("加载数据失败:", err);
          this.$common.showMsg("error", "加载数据失败");
        });
    },
    /**
     * 执行新建/编辑操作
     */
    doCreate() {
      const params = JSON.parse(JSON.stringify(this.form));
      
      // 根据classificationId从backendTreeList中查找对应的code
      // 优先使用categorizeOptions（props传入），如果没有则使用internalCategorizeOptions
      const treeData = this.categorizeOptions && this.categorizeOptions.length > 0 
        ? this.categorizeOptions 
        : this.internalCategorizeOptions;
      if (params.classificationId && treeData && treeData.length > 0) {
        const code = this.findCodeById(treeData, params.classificationId);
        if (code) {
          params.classificationCode = code;
        }
      }
      
      // 处理 titleJson：确保是数组格式，然后转换为字符串
      let titleJsonArray = params.titleJson || [];
    
      // 过滤掉未填写标题的数据
      titleJsonArray = titleJsonArray.filter(
        item => item && item.titleName && item.titleName.trim() !== ""
      );
      //默认标题
      params.title = "";
      titleJsonArray.forEach(item => {
        if(item.titleName&&item.titleName.trim() !== ""&&item.titleName.trim() !== 'undefined'){
          
          params.title += item.titleName;

        }
       
      });
      //允许修改技术老师，技术老师必选
      if(params.teacherIsEdit===1&&!params.teacherId){

          this.$common.showMsg("error", "请选择技术老师");
          return;
      }
     
      // 转换为JSON字符串
      params.titleJson = JSON.stringify(titleJsonArray);
      
      // 处理 contentList：确保是数组格式，然后转换为字符串
      let contentListArray = params.contentList || [];
      // 如果已经是字符串，先解析
      if (typeof contentListArray === "string") {
        try {
          contentListArray = JSON.parse(contentListArray);
        } catch (e) {
          console.warn("解析contentList失败:", e);
          contentListArray = [];
        }
      }
      // 确保是数组
      if (!Array.isArray(contentListArray)) {
        contentListArray = [];
      }
      
      // 直接使用编辑器返回的content，不做任何处理
      // 编辑器返回的content应该是纯HTML字符串，JSON.stringify会自动处理转义
      contentListArray = contentListArray.map(item => ({
        content: String(item.content || ""),
        isEdit: item && typeof item.isEdit !== "undefined" ? item.isEdit : 0
      }));
      
      // 转换为JSON字符串
      // JSON.stringify会自动将数组转换为字符串，并将HTML属性中的引号转义为 \"
      params.content = JSON.stringify(contentListArray);
      //分类类别(1分享物料 2项目管理 3顾客物料 4案例展示 5业务物料 6品宣 7皮科药普)
      params.sourceType = 1;
      delete params.contentList;
      // 未填写的虚拟数据字段不提交
      if (params.browseNum === undefined || params.browseNum === "") {
        delete params.browseNum;
      }
      if (params.likeNum === undefined || params.likeNum === "") {
        delete params.likeNum;
      }
      if (params.forwardNum === undefined || params.forwardNum === "") {
        delete params.forwardNum;
      }
      // 数字型字段统一转为 int32
      const toInt = v => {
        if (v === undefined || v === "") return undefined;
        const n = Number(v);
        return Number.isNaN(n) ? undefined : n;
      };
      const intFields = [
        "classificationId",
        "meetingId",
        "orderNo",
        "state",
        "browseNum",
        "likeNum",
        "forwardNum",
        "teacherId",
        "teacherIsEdit"
      ];
      intFields.forEach(k => {
        const v = toInt(params[k]);
        if (v === undefined) {
          delete params[k];
        } else {
          params[k] = v;
        }
      });
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          if (this.isRepSub) return;
          this.isRepSub = true;
          const req =
            this.form.id > 0
              ? templateMaterialsShareApi.update(params)
              : templateMaterialsShareApi.create(params);
          req
            .then(data => {
              this.postCallback(data);
            })
            .catch(() => {
              this.isRepSub = false;
            });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.$emit("created");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-card {
  overflow: visible;
}
::v-deep .el-dialog__body {
  padding: 10px;
}
.title-tips {
  font-size: 12px;
  color: #8f8e8e;
}

.title-form-item {
  margin-bottom: 10px;
}

.material-info-wrapper {
  margin-left: 10px;
  width: 100%;
  margin-bottom: 20px;
}

.material-info-container {
  display: flex;
  gap: 10px;
}

.material-info-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.material-checkbox {
  flex-shrink: 0;
}

.material-input {
  flex: 1;
}

.material-actions {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}

.reimbursement {
  padding-bottom: 40px;
  // padding: 0 20px;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

// 物料信息容器样式
.material-info-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

// 单个物料信息项样式
.material-info-item {
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 4px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  max-width: 240px;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
}

// 勾选框样式
.material-checkbox {
  margin-right: 10px;

  ::v-deep .el-checkbox__input {
    .el-checkbox__inner {
      border-radius: 50%;
      border-color: #409eff;
    }
  }
}

// 输入框样式
.material-input {
  ::v-deep .el-input__inner {
    border: none;
    background: transparent;
    padding: 0;
    font-size: 14px;

    &::placeholder {
      color: #c0c4cc;
    }

    &:focus {
      border: none;
      box-shadow: none;
    }
  }
}

// 操作按钮容器
.material-actions {
  display: flex;
  gap: 5px;
}

// 操作按钮样式
.action-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  box-shadow: none;

  &.add-btn {
    color: #67c23a;

    &:hover {
      color: #85ce61;
    }
  }

  &.remove-btn {
    color: #f56c6c;

    &:hover {
      color: #f78989;
    }

    &:disabled {
      color: #c0c4cc;
    }
  }

  ::v-deep .el-icon-plus,
  ::v-deep .el-icon-minus {
    font-size: 12px;
  }
}

// 内容区域样式
.content-container {
  width: 100%;
}

.content-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-item-wrapper {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.content-item-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 6px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e4e7ed;
  border-radius: 8px 8px 0 0;
}

.content-item-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.content-item-body {
  padding: 16px;
}

.content-editor {
  margin-bottom: 16px;
}

.content-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.content-actions {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.content-checkbox {
  ::v-deep .el-checkbox__label {
    font-size: 14px;
    color: #606266;
  }
}

.action-link {
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  padding: 0 12px;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid transparent;
  font-weight: 500;

  &.add-link {
    color: #67c23a;
    border-color: #67c23a;

    &:hover {
      background-color: #67c23a;
      color: #fff;
    }
  }

  &.delete-link {
    color: #f56c6c;
    border-color: #f56c6c;

    &:hover {
      background-color: #f56c6c;
      color: #fff;
    }

    &.disabled {
      color: #c0c4cc;
      border-color: #c0c4cc;
      cursor: not-allowed;

      &:hover {
        background-color: transparent;
        color: #c0c4cc;
        border-color: #c0c4cc;
      }
    }
  }
}
// 备用方案：直接让 content 在某些情况下允许溢出
::v-deep .el-dialog__body {
  position: relative;
}
.address {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 12;
}
</style>
